<script setup lang="ts">
    import { Select } from '@/components/ui/form';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    const props = defineProps<{
        modelValue: string;
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string): void;
    }>();

    const { t } = useI18n();

    const value = computed({
        get: () => props.modelValue,
        set: (newValue: string) => emit('update:modelValue', newValue),
    });

    const statusOptions = computed(() => [
        { value: 'open', label: t('payrolls.grouping.open') },
        { value: 'closed', label: t('payrolls.grouping.closed') },
        { value: 'all', label: t('payrolls.grouping.all') },
    ]);
</script>

<template>
    <Select 
        v-model="value"
        :options="statusOptions"
    />
</template>
